import React from 'react';
import { Box } from '@mui/material';
import PlaceholderPage from '../../components/Common/PlaceholderPage';
import { brand, ink } from '../../theme/tokens';
import Seo from '../../components/Common/Seo';

// See AboutPage: the shared placeholder's footnote is #999 (2.85:1), so the
// text colours are restated here from the checked ink ramp.
const placeholderInkSx = {
  '& .MuiTypography-h4': { color: ink.primary, letterSpacing: '-0.01em' },
  '& .MuiTypography-body1': { color: ink.secondary },
  '& .MuiTypography-caption': { color: ink.muted },
  '& .MuiSvgIcon-root': { color: brand.brown },
};

const ExperiencesPage = () => {
  return (
    <Box sx={placeholderInkSx}>
      <Seo
        title="Farm Experiences & Visits in Birbhum"
        description="Farm walks, hands-on activities and seasonal visits at our organic farm in Birbhum, West Bengal. Get in touch and we will plan a day around your visit."
        path="/experiences"
      />
      <PlaceholderPage 
        title="Farm Experiences" 
        description="Unique farm activities and educational tours" 
      />
    </Box>
  );
};

export default ExperiencesPage;